







































































import { Mixins } from "vue-mixin-decorator";
import { Component, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import GeneralMixin from "@/mixin";
import { ISiteListRequest, ISite } from "@/types/site";
import { IPagination } from "@/types";

@Component({
  components: {}
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("site/getList")
  public getList!: (request: ISiteListRequest) => boolean;

  @Getter("site/list")
  public siteList!: ISite[];

  @Getter("site/pagination")
  public pagination!: IPagination<ISite>;

  @Watch("params.page")
  public async changePage() {
    await this.getList(this.params);
  }

  @Mutation("site/clear")
  public clear!: () => void;

  //
  // variables
  //
  public params: ISiteListRequest = {
    status: 1,
    search: "",
    page: 1,
    per_page: 4
  };
  //
  // methods
  //
  private created() {
    this.clear();
    this.getSiteList();
  }

  // 現場一覧の取得を行う
  private async getSiteList() {
    this.params.page = 1;
    await this.getList(this.params);
  }
}
